import { atom, selector } from 'recoil'
import { HomeTerms, JoinTerms } from 'src/types/type'

const TelTypeState = atom({
    key: 'TelTypeState',
    default: 0
})

const TelNumState = atom({
    key: 'TelNumState',
    default: [{
        state: '',
        check: false
    }]
})

const certCheck = atom<boolean>({
    key: 'certCheck',
    default: false
})
const CertNumState = atom({
    key: 'CertNumState',
    default: ''
})
const SecurityNumState = atom({
    key: 'SecurityNumState',
    default: ''
})
const SecurityTranIdState = atom({
    key: 'SecurityTranIdState',
    default: ''
})
const InquiryTypeState = atom({
    key: 'InquiryTypeState',
    default: 'none'
})
const InquiryName = atom({
    key: 'InquiryName',
    default: [{
        state: '',
        check: false
    }]
})
const InquiryPhoneNum = atom({
    key: 'InquiryPhoneNum',
    default: [{
        state: '',
        check: false
    }]
})
const InquiryEmail = atom({
    key: 'InquiryEmail',
    default: [{
        state: '',
        check: false
    }]
})
const InquiryTitle = atom({
    key: 'InquiryTitle',
    default: [{
        state: '',
        check: false
    }]
})
const InquiryContent = atom({
    key: 'InquiryContent',
    default: ''
})
const TimeOutState = atom({
    key: 'TimeOutState',
    default: ''
})
const HeaderUserTab = atom({
    key:"HeaderUserTab",
    default: false
})
const TranIdState = atom({
    key: 'TranIdState',
    default: ''
})
const RecapAuthToken = atom({
    key:'RecapAuthToken',
    default: ''
})
const RefreshRecapAuthToken = atom({
    key:'RefreshRecapAuthToken',
    default: false
})
const MoHeaderMenuToggle = atom({
    key: 'MoHeaderMenuToggle',
    default: false
})
const DouModalOption = atom({
    key: "DouModalOption",
    default: ""
})
const HomeTermsState = atom<HomeTerms[]>({
    key: 'HomeTermsState',
    default: [
        {TermsIdx: 0, Terms: []}, // SKTTerms
        {TermsIdx: 0, Terms: []}, // KTTerms
        {TermsIdx: 0, Terms: []}, // LGUPTerms
    ],
})
const JoinTermsState = atom<JoinTerms[]>({
    key: 'JoinTermsState',
    default: [
        {TermsIdx: 0, Terms: [], TermsOrder: ''}, // SKTTerms
        {TermsIdx: 0, Terms: [], TermsOrder: ''}, // KTTerms
        {TermsIdx: 0, Terms: [], TermsOrder: ''}, // LGUPTerms
    ],
})

const JoinTermsSelector = selector({
    key: 'JoinTermsSelector',
    get: ({ get }) => get(JoinTermsState)?.[get(TelTypeState)],
});

export {
    certCheck, CertNumState, DouModalOption, HeaderUserTab, HomeTermsState, InquiryContent, InquiryEmail,
    InquiryName, InquiryPhoneNum, InquiryTitle, InquiryTypeState, JoinTermsSelector, JoinTermsState, MoHeaderMenuToggle, RecapAuthToken, RefreshRecapAuthToken, SecurityNumState, SecurityTranIdState, TelNumState, TelTypeState, TimeOutState,
    TranIdState
}

